interface Translation {
  title?: string
  label?: string
  url?: string
}

interface FooterItem {
  translations: Translation[]
}

interface FooterColumn {
  id: number
  status: string
  translations: Translation[]
  footer_item_id: FooterItem[]
}

export interface FooterResponse {
  data: FooterColumn[]
}
export enum Status {
  DRAFT = 'draft',
  PUBLISHED = 'published',
  ARCHIVED = 'archived',
}
